import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import { COLOR_TEXT_PRIMARY } from "../../styles/colors";
import { trackEvent, GA_EVENTS } from "../../utils/analytics";

interface ProblemHintsProps {
  problemId: string;
  hints: string[];
}

/** Hints stay hidden until the player reveals them, one at a time. */
export const ProblemHints: React.FC<ProblemHintsProps> = ({ problemId, hints }) => {
  const [revealedCount, setRevealedCount] = useState(0);

  useEffect(() => {
    setRevealedCount(0);
  }, [problemId]);

  const handleReveal = () => {
    trackEvent(GA_EVENTS.PROBLEM_HINT_REVEALED, { problem_id: problemId, hint_number: revealedCount + 1 });
    setRevealedCount((count) => count + 1);
  };

  return (
    <Box data-testid="problem-hints" sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {hints.slice(0, revealedCount).map((hint, index) => (
        <Box
          key={index}
          data-testid="problem-hint"
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "flex-start",
            backgroundColor: "#fff8e1",
            borderRadius: "8px",
            padding: "8px 10px",
          }}
        >
          <LightbulbOutlinedIcon sx={{ fontSize: 18, color: "#f59e0b", mt: "2px" }} />
          <Typography variant="body2" sx={{ color: COLOR_TEXT_PRIMARY }}>
            {hint}
          </Typography>
        </Box>
      ))}
      {revealedCount < hints.length && (
        <Button
          size="small"
          variant="outlined"
          startIcon={<LightbulbOutlinedIcon />}
          onClick={handleReveal}
          data-testid="reveal-hint-btn"
          sx={{ alignSelf: "flex-start", textTransform: "none" }}
        >
          Reveal hint {revealedCount + 1} of {hints.length}
        </Button>
      )}
    </Box>
  );
};
